/**************************************************
 * Nombre:       Apartado_Preguntas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Preguntas from "../Tarjeta/Tarjeta_Preguntas";
import {useState} from "react";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Apartado_Preguntas = ({item}) => {
    const {sCell} = useResponsive()
    const [escogido, setEscogido] = useState({});

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: sCell ? 'center' : 'left'}}>
                            <Typography sx={{
                                fontSize: 24,
                                fontWeight: 700,
                                color: '#1B0B3B',
                                textTransform: 'uppercase',
                                textAlign: sCell ? 'center' : 'left',
                                lineHeight: 1.3
                            }}>
                                PREGUNTAS FRECUENTES
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'left', mt: 3}}>
                            <Typography sx={{
                                fontSize: 14,
                                fontWeight: 300,
                                color: '#1B0B3B',
                                textAlign: sCell ? 'center' : 'left',
                                lineHeight: 1.3,
                                fontStyle: 'italic',
                            }}>
                                {item.parrafoPreguntas}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 5}}
                            sx={{mt: 6}}
                            spacing={2}
                        >

                            {item && item.preguntas && item.preguntas.map((item, i) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Preguntas item={item} escogido={escogido} setEscogido={setEscogido}/>
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Apartado_Preguntas

